// src/components/originator-pending.js

import React, { useState, Suspense, useEffect, Fragment} from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { RestHelper } from '../helper/restHelper'
import { ApptNotesHandler, GeneralFileUpload, GeneralGroupFileUpload, OrigEditRequest, PopupOverlay, GeneralUploadStatus } from '../components'



const OrigViewRequest = (data) => {  

  const [requestDetails, setRequestDetails] = useState([])
  const [isLoaded, setIsLoaded] = useState(false)
  const [showDetails, setShowDetails] = useState(true)
  const [showResponse, setShowResponse] = useState(false)
  const [updateResponse, setUpdateResponse] = useState([])
  const [showEditForm, setShowEditForm] = useState(false)
  const [passedData, setPassedData] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [editResponse, setEditResponse] = useState([])
  const [showResult, setShowResult] = useState(false)
  const [showPopup, setShowPopup] = useState(false)
  const [passedMessage, setPassedMessage] = useState('')
  const [passedObject, setPassedObject] = useState('')
  const [isChecked, setIsChecked] = useState(false)
  const [isApproved, setIsApproved] = useState(false)

  const [showFileUpload, setShowFileUpload] = useState(true)
  const [showNotaryApprovedSlider, setShowNotaryApprovedSlider] = useState(false)

  const dropZoneStyle2 = {
    border: '2px solid #666',       // Medium gray border
    borderRadius: '5px',
    padding: '5px',
    textAlign: 'left',
    color: '#333',                  // Darker text color for contrast
    cursor: 'arrow',
    //backgroundColor: '#ddd',        // Medium gray background
  };

  const api = RestHelper()

  const reqData = { 'action' : 'get', 'id' : data.requestId }
  const options = {}
  if(!isLoaded){
    api
        .postCreate('/appt-manage-escrow', options, reqData)
        .then(res => loadRequestDetails(res))
        .catch(err => console.log(err))
    setIsLoaded(true)
    }

function loadRequestDetails(res) {
  setRequestDetails(res)
  setIsChecked(res[0]['fileUploadStatus'])
  setIsApproved(res[0]['uploadsApproved'])
  setShowNotaryApprovedSlider(res[0]['notaryUploadStatus'])
}

 function dateFormat (inputDate) {
       const dateArray = inputDate.split("-")
       const date = dateArray[1] + '/' + dateArray[2] + '/' + dateArray[0]
       return date
    }

  function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return '';
    var cleaned = phoneNumber.replace(/\D/g, '');
    if (cleaned.length > 10) {
      cleaned = cleaned.substring(0, 10);
    }
    if (cleaned.length < 10) {
      return phoneNumber;
    }
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }

 function editRequest(inputData) {
  setPassedData(inputData)
  setShowFileUpload(false)
  setShowDetails(false)
  setShowEditForm(true)
 }

 const getInvoice = (e) => {
  const options = {}
  const fileData = { 'unique_id': data.requestId, 'file_name': e }
  api
    .postCreate('/get-invoice-file', options, fileData)
    .then(res => window.open(res.get_url, "_blank"))
    .catch(err => console.log(err))
}

function clearEditRequest() {
  setShowFileUpload(true)
  setShowDetails(true)
  setShowEditForm(false)
 }

 function clearResponseMessage() {
  setIsLoading(false)
  setShowFileUpload(true)
  setShowDetails(true)
  setShowResponse(false)
  const reqData = { 'action' : 'get', 'id' : data.requestId }
  const options = {}
  api
    .postCreate('/appt-manage-escrow', options, reqData)
    .then(res => setRequestDetails(res))
    .catch(err => console.log(err))
}

 function updateOrder(inputData) {
  setIsLoading(true)
  setShowEditForm(false)
  const reqData = { 'action' : 'update', 'id' : data.requestId, 'data' : inputData.request, 'updates' : inputData.changedData}
  const options = {}
  api
    .postCreate('/appt-manage-escrow', options, reqData)
    .then(res => displayResponse(res))
    .catch(err => console.log(err))
 }

 function displayResponse(res) {
  const response = res
  setUpdateResponse(response)
  setIsLoading(false)
  setShowResponse(true)
 }

 function clearModal(){
  setShowPopup(false)
 }
 function callDeleteFileService(inputData) {
  const reqData = { 'action' : 'deleteFile', 'id' : data.requestId, 'fileName' : inputData}
  const options = {}
  api
    .postCreate('/appt-manage-escrow', options, reqData)
    .then(res => clearResponseMessage())
    .catch(err => console.log(err))
 }

 function doNothing(){
  
 }

 const setUploadComplete = (event) => {
  var checkStatus = (event)
  setIsChecked(checkStatus)
  const reqData = { 'action' : 'markFilesUploadedStatus', 'id' : data.requestId, 'fileStatus' : checkStatus}
  const options = {}
  api
    .postCreate('/appt-manage-escrow', options, reqData)
    .then(res => doNothing())
    .catch(err => console.log(err))
 }

 const setUploadsApproved = (event) => {
  var checkStatus = (event)
  setIsApproved(checkStatus)
  const reqData = { 'action' : 'markUploadsApprovedStatus', 'id' : data.requestId, 'approvedStatus' : checkStatus}
  const options = {}
  api
    .postCreate('/appt-manage-escrow', options, reqData)
    .then(res => doNothing())
    .catch(err => console.log(err))
 }


 function deleteFile(e){
  //callDeleteFileService(e)
  var messageToSend = 'Are you sure you wish to delete ' + e + '?'
  setPassedMessage(messageToSend )
  setPassedObject(e)
  setShowPopup(true)
  const btnRef = document.getElementById(e)
  btnRef.blur()
  console.log(e)
 }

 function confirmAction(e){
  callDeleteFileService(e)
 }
 function setAction(passedAction) {
  if (passedAction === 'write') {
    return 'Uploaded'
  }
  else {
    return 'Downloaded'
  }
}   
function convertTimeToAMPM(time24, time_TBD) {
    if (time_TBD){
       return 'TBD'
    }
    var hours = parseInt(time24.substr(0, 2));
    var minutes = parseInt(time24.substr(3));
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    var minutesStr = minutes < 10 ? '0' + minutes : minutes;
    var time12 = hours + ':' + minutesStr + ' ' + ampm;
    return time12;
    }
    function convertToSimpleDateMessage(updatedTime) {
      const date = new Date(updatedTime*1000)
      const dateString = date.toLocaleString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      })
      return dateString
    }
    const getTempUrl = (e) => {
        const options = {}
        const fileData = {'unique_id' : data.requestId, 'file_name' : e }
        api
            .postCreate('/get-stored-file', options, fileData)
            /*.then(res => window.open(res.get_url,"_blank"))*/
            .then(res => window.location.href = res.get_url)
            .catch(err => console.log(err))
      }
    

  return(
   <div className="bg-white rounded-xl">
    {showDetails && (<div>
    {requestDetails.map((items =>
            <div>
                <div className="flex items-center justify-between mb-6">
                    <h2 className='text-xl font-semibold text-neutral-800'>Order Details</h2>
                    <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors" type="button" onClick={() => editRequest(items)}>Edit Order Details</button>
                </div>

                <div className='card-section'>
                    <div className="card-section-header">
                        <h3 className="card-section-title">Appointment Information</h3>
                        <div className="card-section-title-bar"></div>
                    </div>
                    <div className="card-section-body">
                        <div className="detail-row">
                            <div className="detail-label">File Number</div>
                            <div className="detail-value">{items.fileNumber}</div>
                        </div>
                        <div className="detail-row">
                            <div className="detail-label">Status</div>
                            <div className="detail-value">
                                <span className="badge badge-primary">{items.Status}</span>
                            </div>
                        </div>
                        <div className="detail-row">
                            <div className="detail-label">Signer Name</div>
                            <div className="detail-value">{items.appt_contactName}</div>
                        </div>
                        <div className="detail-row">
                            <div className="detail-label">Location</div>
                            <div className="detail-value">{items.appt_street}, {items.appt_city}, {items.appt_state} {items.appt_zip}</div>
                        </div>
                        <div className="detail-row">
                            <div className="detail-label">Date and Time</div>
                            <div className="detail-value">{dateFormat(items.appt_date)} at {convertTimeToAMPM(items.appt_time, items.appt_time_TBD)} {items.appt_timeZone}</div>
                        </div>
                        <div className="detail-row">
                            <div className="detail-label">Assigned Signing Agent</div>
                            <div className="detail-value">
                              <div className="text-neutral-800">{items.Notary}</div>
                              {items.notaryPhone && <div className="text-sm text-neutral-500">{formatPhoneNumber(items.notaryPhone)}</div>}
                            </div>
                        </div>
                        <div className="detail-row">
                            <div className="detail-label">Escrow Officer</div>
                            <div className="detail-value text-neutral-800">{items.appt_escrow}</div>
                        </div>
                        <div className="detail-row">
                            <div className="detail-label">Additional Notes</div>
                            <div className="detail-value">{items.comments}</div>
                        </div>
                        <div className="detail-row">
                            <div className="detail-label">Invoice</div>
                            <div className="detail-value">
                                <button className="text-blue-600 hover:text-blue-800 hover:underline font-medium" title="Invoice File" type="button" onClick={() => { getInvoice(items.invoiceFileName) }}>{items.invoiceFileName}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card-section'>
                    <div className="card-section-header">
                        <h3 className="card-section-title">File Management</h3>
                        <div className="card-section-title-bar"></div>
                    </div>
                    <div className="card-section-body">
                    {showFileUpload &&
                      <GeneralGroupFileUpload requestId={data.requestId} clearResponseMessage={clearResponseMessage}/>
                    }

                    <div className="mb-6">
                        <h4 className="text-base font-semibold text-neutral-800 mb-3">Upload Status</h4>
                        <div className='flex items-center gap-3 p-4 bg-neutral-50 rounded-lg border border-neutral-200 mb-3'>
                            <label className="relative inline-flex items-center cursor-pointer">
                                <input checked={isChecked} type="checkbox" onChange={(e) => setUploadComplete(e.target.checked)} className="sr-only peer"/>
                                <div className="w-11 h-6 bg-neutral-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-neutral-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                            </label>
                            <span className="text-neutral-700 font-medium">Mark all files as uploaded</span>
                        </div>
                        {showNotaryApprovedSlider &&
                        <div className='flex items-center gap-3 p-4 bg-neutral-50 rounded-lg border border-neutral-200'>
                            <label className="relative inline-flex items-center cursor-pointer">
                                <input checked={isApproved} type="checkbox" onChange={(e) => setUploadsApproved(e.target.checked)} className="sr-only peer"/>
                                <div className="w-11 h-6 bg-neutral-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-neutral-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                            </label>
                            <span className="text-neutral-700 font-medium">Uploaded docs reviewed and approved for notary drop</span>
                        </div>}
                    </div>

                    <div>
                        <h4 className="text-base font-semibold text-neutral-800 mb-3">File Attachments</h4>
                        <div className="space-y-3">
                            {items.fileLogInfo.map(o =>
                                <div className="bg-neutral-50 rounded-lg border border-neutral-200 p-4" key={o.fileName}>
                                    <div className="flex items-center gap-3 mb-3">
                                        <button className="text-red-500 hover:text-red-700 p-2 rounded-lg hover:bg-red-50 transition-colors" title="Delete File" id={o.fileName} onClick={() => deleteFile(o.fileName)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                            </svg>
                                        </button>
                                        <button className="text-blue-600 hover:text-blue-800 hover:underline font-medium" title="Download File" type="button" onClick={() => {getTempUrl(o.fileName)}}>{o.fileName}</button>
                                    </div>
                                    <div className="pl-10 space-y-1">
                                        {o.fileReadInfo.map(info =>
                                            <div className="flex items-center gap-2 text-sm text-neutral-600" key={info.loggedTime}>
                                                <span>{setAction(info.action)} by {info.user} - {convertToSimpleDateMessage(info.loggedTime)}</span>
                                                <GeneralUploadStatus confirm={info.confirmed} action={info.action}/>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    </div>
                </div>

                <Fragment>
                  <ApptNotesHandler requestId={data.requestId}/>
                  {showPopup && <PopupOverlay clearModal = {clearModal} confirmAction = {confirmAction} passedMessage = {passedMessage} passedObject = {passedObject}/>}
                </Fragment>

              </div>))
  }      
</div>
  )}
  {showResponse &&
   <div className="bg-white rounded-xl shadow-md p-6 border border-neutral-200">
    {updateResponse.map((item =>
      <div key={item.message}>
        <div className="text-neutral-800 mb-4 p-4 bg-green-50 border border-green-200 rounded-lg">
            {item.message}
        </div>
        <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors" type="button" onClick={() => clearResponseMessage()}>Return to Order Details</button>
      </div>
    ))}
    </div>
  }
  {showEditForm && <OrigEditRequest items={passedData} cancelEdit = {clearEditRequest} updateOrder = {updateOrder}/>
  }
  {isLoading &&
    (<div className="bg-white rounded-xl shadow-md p-8 border border-neutral-200">
      <div className="flex flex-col items-center justify-center">
        <div className="text-neutral-600 mb-4 text-center">Please wait while we update the order and send out notifications...</div>
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
      </div>
     </div>)}
  </div>)}

export default OrigViewRequest;